import React, {useEffect, useState, useMemo} from 'react';
import * as R from 'ramda';
import { createPortal } from 'react-dom';
import { inject, observer } from 'mobx-react';
import { style } from 'utils/image';
import intl from 'react-intl-universal';
import ReactCopy from 'react-copy-to-clipboard';
import ReactSVG from 'react-svg';
import './ShareToast.scss';
import Mask from 'components/Mask';

const { CopyToClipboard } = ReactCopy;


const shareModalRef = window.document.createElement('div');
shareModalRef.className = 'person-share-portal';

const TITLE_MAX = 28;
const DESC_MAX = 39;

export const ShareModal = (props:{
  getDefaultShare:()=>any,
  onEditClick:(data:any)=>void,
  onLinkClick:()=>void,
  onClose:()=>void,
  hideSubTitle?: boolean,
})=>{
  const {hideSubTitle, getDefaultShare, onEditClick, onLinkClick, onClose} = props;

  useEffect(() => {
    window.document.body.appendChild(shareModalRef);

    return () => {
      if (shareModalRef && shareModalRef.parentNode) {
        window.document.body.removeChild(shareModalRef);
      }
    };
  }, []);

  const [editMode, setEditMode] = useState(false);

  useEffect(()=>{
    if(editMode) {
      shareModalRef.style.height = `320px`;
    }else {
      shareModalRef.style.height = `250px`;
    }
  }, [editMode]);

  const [editData, setEditData] = useState({
    title: '',
    desc: '',
    image: '',
  } as any);
  const [defaultShare, setDefaultShare] = useState({
    title: '',
    desc: '',
    image: ''
  } as any);

  useEffect(()=>{
    const share = getDefaultShare();
    setDefaultShare(share);
    setEditData(share);
  }, [getDefaultShare]);


  const shareImage = useMemo(()=>{
    const image = decodeURIComponent(R.pathOr('',['image'], defaultShare));
    const isStartWithHttpOrDoubleSlash = R.startsWith('http', image) || R.startsWith('//', image);
    if(isStartWithHttpOrDoubleSlash){
        return image;
    } else {
      return style(image);
    }
  },[defaultShare]);

  return createPortal(
    <>
      <Mask />
      {editMode ? <>
        <div className="share-modal">
          <div className="modal-title">{intl.get('SettingShare')}</div>
          <div className="modal-content vertical">
            <div className="field-title">{intl.get('PleaseSettingShare')}</div>
            <div className="field-input">
              <input placeholder={defaultShare.title} maxLength={TITLE_MAX} onChange={(e:any)=>{
                setEditData({
                  ...editData,
                  title: e.target.value,
                });
              }} value={editData.title} />
              <div className="input-count">{(editData.title || "").length}/{TITLE_MAX}</div>
            </div>
            <div className="field-desc">
              <div className="field-textarea">
                <textarea placeholder={defaultShare.desc} maxLength={DESC_MAX} onChange={(e:any)=>{
                  setEditData({
                    ...editData,
                    desc: e.target.value,
                  });
                }} value={editData.desc} />
                <div className="input-count">{(editData.desc || "").length}/{DESC_MAX}</div>
              </div>
              <img src={shareImage} className="share-img" />
            </div>
            <div className="important-tip">{intl.get('IfNotEditUseDefaultShare')}</div>
            <button onClick={()=>onEditClick(editData)} className="button primary">{intl.get('ConfirmSettingAndShare')}</button>
          </div>
          <a className="modal-close" onClick={()=>{
            setEditMode(false);
          }}>
            <img src={require('../../assets/x-36.png')} />
          </a>
        </div>
      </> : <div className="share-modal">
        <div className="modal-title">{intl.get('PleaseShare')}</div>
        {hideSubTitle ? null : <div className="modal-sub-title">
          {intl.get('PersonShareTip')}
        </div>}
        <div className="modal-content">
          <div
            className="share-type"
            onClick={()=>{
              setEditMode(true);
            }}
          >
            <div className="share-icon">
              <ReactSVG
                  style={{
                    width: 32,
                    height: 32,
                  }}
                  src={require('../../svg/share-svg-lined.svg')}
              />
            </div>
            <div className="share-name">{intl.get('PersonCustomShare')}</div>
          </div>
          <CopyToClipboard
            text={editData.url}
            onCopy={onLinkClick}
          >
            <div className="share-type">
              <div className="share-icon">
                <ReactSVG
                    style={{
                      width: 32,
                      height: 32,
                    }}
                    src={require('../../svg/link.svg')}
                />
              </div>
              <div className="share-name">{intl.get('ShareLink')}</div>
            </div>
          </CopyToClipboard>
        </div>
        <a className="modal-close" onClick={onClose}>
          <img src={require('../../assets/x-36.png')} />
        </a>
      </div>}
    </>,
    shareModalRef
  );
};

export default inject('rootStore')(observer(ShareModal));
